module.exports = require('./build/mediaelement-and-player.js');



//////////////////
// WEBPACK FOOTER
// H:/web-projects/chronoshieldglampingclone/app/public/wp-content/themes/sage9/node_modules/mediaelement/full.js
// module id = 8
// module chunks = 0